import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase/client";

export function Onboarding() {
  const navigate = useNavigate();
  const [zip, setZip] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);

    if (!/^\d{5}$/.test(zip)) {
      setError("Enter a 5-digit US zip code.");
      return;
    }

    setBusy(true);
    const { data: userData, error: userError } = await supabase.auth.getUser();
    if (userError || !userData.user) {
      setBusy(false);
      setError("Session expired — please sign in again.");
      return;
    }

    // Save zip to user metadata. Full USDA-zone lookup is deferred to Week 2.
    const { error: updateError } = await supabase.auth.updateUser({
      data: { zip_code: zip },
    });
    setBusy(false);

    if (updateError) {
      setError(updateError.message);
      return;
    }
    navigate("/app/today", { replace: true });
  }

  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center px-6"
      style={{ background: "#FFFCF8", color: "#1A1620" }}
    >
      <div className="w-full max-w-sm">
        <h1 className="font-display text-3xl" style={{ color: "#8A4E9C" }}>
          Where do you garden?
        </h1>
        <p className="mt-1 text-sm" style={{ color: "#9A8A78" }}>
          Your zip lets Sage figure out your USDA hardiness zone. We only use it for plant timing.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <label className="block">
            <span className="text-sm font-medium">Zip code</span>
            <input
              type="text"
              inputMode="numeric"
              pattern="\d{5}"
              maxLength={5}
              required
              autoFocus
              value={zip}
              onChange={(e) => setZip(e.target.value.replace(/\D/g, ""))}
              className="mt-1 w-full rounded-lg px-3 py-2 text-base"
              style={{ border: "1px solid #EAE4DA", background: "#FFFFFF" }}
            />
          </label>

          {error ? (
            <p
              role="alert"
              className="rounded-md px-3 py-2 text-sm"
              style={{ background: "#FBEDE6", color: "#A05A38" }}
            >
              {error}
            </p>
          ) : null}

          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-full px-5 py-3 text-base font-medium transition-opacity hover:opacity-90 disabled:opacity-60"
            style={{ background: "#8A4E9C", color: "#FFFFFF" }}
          >
            {busy ? "Saving…" : "Continue"}
          </button>
        </form>
      </div>
    </main>
  );
}
